import { SaveProtocolLaunchItemDTO } from "../LAIncedenceDashboard/LAIncidentDashboardModel";

export class ProtocolTemplateDTO{
  templateId: string;
  title: string;
  items: SaveProtocolLaunchItemDTO[] = [];
}